export default "__VITE_ASSET__C7NvC2eC__"